import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'

import { CommonService } from 'src/app/services/common/common.service'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { tap, mergeMap, catchError, of } from 'rxjs'
import {
  load_dashboard_action,
  load_dashboard_failure,
  load_dashboard_success,
  load_entity_wise_data_action,
  load_entity_wise_data_failure,
  load_entity_wise_data_success
} from '../action/dashboard.action'
import { login_success } from '../action/auth.action'
import { DashboardService } from 'src/app/services/dashboard/dashboard.service'

@Injectable()
export class DashboardEffects {
  constructor(private actions$: Actions, private cs: CommonService, private dashboardService: DashboardService) {}

  dashboardRedirect$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(login_success),
        tap(action => {
          this.cs.routeTo(GlobalConstants.ROUTING.DASHBOARD)
        })
      )
    },
    { dispatch: false }
  )

  loadUserDashboard$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(load_dashboard_action),
      mergeMap(action =>
        this.dashboardService
          .getUserDashboard(action.from, action.to)
          .pipe(catchError((error: any) => of(load_dashboard_failure({ data: null, error: error }))))
      ),
      mergeMap(response => [load_dashboard_success(response)])
    )
  })

  loadEntityWiseData$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(load_entity_wise_data_action),
      mergeMap(action =>
        this.dashboardService
          .getEntityWiseData(action.companyEntities, action.from, action.to)
          .pipe(catchError((error: any) => of(load_entity_wise_data_failure({ data: null, error: error }))))
      ),
      mergeMap(response => [load_entity_wise_data_success(response)])
    )
  })
}
